import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=7e9e4dac&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7e9e4dac&prod&scoped=true&lang=css&external"
import style1 from "./Services.vue?vue&type=style&index=1&id=7e9e4dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9e4dac",
  null
  
)

export default component.exports